import { render, staticRenderFns } from "./ReportDevelopmentDetails.vue?vue&type=template&id=1ba54940"
import script from "./ReportDevelopmentDetails.vue?vue&type=script&lang=js"
export * from "./ReportDevelopmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports